module.exports = __webpack_public_path__ + "img/ms.df1f038b.svg";